<template>
    <div :style="{
        ...messageColors,
        //backgroundColor: determineColor(message),
        ...(extendedStyle || {}),
        'background-color': isEmoji() ? 'transparent' : messageColors.backgroundColor,
    }" :class="{
            translatable: isTranslatable(),
            emoji: isEmoji(),
        }" class="sc-message--text">
        <QuoteMessage :message="message.raw.replyTo" v-if="message.raw.replyTo && !replyMode" />
        <!--        <div class="edit-icon">-->
        <!--            <icon-edit />-->
        <!--        </div>-->
        <template>
            <div :style="{ background: messageColors.backgroundColor }" class="sc-message--toolbox">
                <button v-if="me && message.id != null && message.id != undefined" @click="$emit('remove')">
                    <icon-base :color="messageColors.color" icon-name="remove" width="10">
                        <icon-cross />
                    </icon-base>
                </button>
                <slot :me="me" :message="message" name="text-message-toolbox"></slot>
            </div>
        </template>
        <span v-if="isGroupMessage" class="whatsapp-number-first" @click.stop="showWhatsappChatStarterModal = true">
            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }">{{ whatsappAuthorName }} - {{
                whatsappAuthorNumber }}</a>
        </span>
        <slot :me="me" :message="message" :messageColors="messageColors" :messageText="messageText">
            <div :class="{ 'translatable-content-wrapper': isTranslatable() }">
                <SupsisText :visitorId="visitorId" :message="message">
                    <template #content>
                        <div :class="{ 'after-translate-top': isTranslatable() }"
                            style="display: flex; flex-direction: column">
                            <span class="sc-message--text-content m-1 ml-3 mr-3"
                                style="word-break: break-word; word-break: break-word"
                                :style="{ color: getWhatsappNumberColor() }" v-html="messageText"></span>
                        </div>
                    </template>
                </SupsisText>
                <div v-if="isTranslateOpen && !!translate" :class="{ 'after-translate-bottom': isTranslatable() }"
                    style="display: flex; flex-direction: column; border-radius: 0">
                    <TranslatedText v-if="isTranslatable()" :data="translate" class="ml-3" />
                    <span v-if="!translate && isTranslateOpen && myLang !== message.raw.baseLang"
                        class="ml-3 text-info edit-icon" style="cursor: pointer" @click="translateMsg">
                        <a class="translate-this-text" v-if="translating"><b-spinner small variant="danger" type="grow"
                                class="align-middle" />
                            {{ $t("message.translating") }}
                        </a>
                        <a class="translate-this-text" v-else>
                            <span class="md-icon">translate</span>
                        </a>
                    </span>
                </div>
                <div :class="{ 'after-translate-bottom': !!translate && isTranslateOpen }" style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding: 0 0.3rem;
                    ">
                    <span v-if="commentReplyLabel" class="comment-reply-label"
                        :style="{ color: getWhatsappNumberColor() }">
                        {{ commentReplyLabel }}
                    </span>
                    <div style="display: flex; gap: 4px; align-items: center; margin-left: auto;">
                        <span v-if="message.data.meta" :style="{ color: getWhatsappNumberColor() }"
                            class="sc-message-meta-new" v-tippy="{
                                content: formatDate(message),
                                followCursor: true,
                                placement: 'top',
                            }">{{ metaShorter(message.data.meta) }}
                        </span>
                        <span v-if="message.data.meta2" :style="{ color: getWhatsappNumberColor() }"
                            class="sc-message--meta2">{{ message.data.meta2 }}
                        </span>
                        <span v-if="isGroupMessage" class="sc-message-meta-new whatsapp-number"
                            @click.stop="showWhatsappChatStarterModal = true">
                            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }">{{
                                whatsappAuthorName }} -
                                {{ whatsappAuthorNumber }}</a>
                        </span>
                    </div>
                </div>
            </div>
        </slot>
        <Modal2 v-if="showWhatsappChatStarterModal" @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')" :showFooter="false">
            <WhatsappChatStarter :default-phone-number="whatsappAuthorNumber" channel-override phone-number-override
                @close="showWhatsappChatStarterModal = false" :default-name="whatsappAuthorName" />
        </Modal2>
    </div>
</template>

<script>
import IconBase from "./../components/IconBase.vue";
import IconEdit from "./../components/icons/IconEdit.vue";
import IconCross from "./../components/icons/IconCross.vue";
import SupsisText from "../../common/SupsisText.vue";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";
import store from "./../store/";
import { log2 } from "../../../utils/log2";
import { mapState } from "vuex";
import TranslatedText from "../TranslatedText";
import { sendSocketMessage } from "../../../utils/socketStream";
import { systemMessageStream } from "../../../utils/systemPubSub";
import { SanitizeHtml } from "../../../utils/utils";
import { filter, map } from "rxjs/operators";
import _ from "lodash";
import QuoteMessage from "../QuoteMessage.vue";
import StringUtils from "../../../utils/StringUtils";
import Modal2 from "../../common/Modal2.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import formatter from "../../../utils/formatter";

const log = log2("TextMessage");

export default {
    data() {
        return {
            store,
            colors: ["#1BC5BD", "#725c31", "#3699FF", "#f64e60", "#bb71ff", "#FF7CC8", "#F4E151", "#7994C7", "#BA9292"],
            translating: false,
            translateOff: true,
            showWhatsappChatStarterModal: false,
        };
    },
    props: {
        visitorId: {
            type: String,
            required: false,
        },
        isChatWindow: { type: Boolean, default: false },
        isPrivateMessage: {
            type: Boolean,
            default: false,
            required: false,
        },
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        isColored: {
            type: Boolean,
            default: false,
            required: false,
        },
        replyMode: {
            type: Boolean,
            default: false,
        },
        disableTranslation: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            userName: (state) => (state.auth.user ? state.auth.user.name : ""),
            myLang: (state) => _.get(state.auth.user, "lang", "tr"),
            language: (state) => state.language.language,
            autoTranslate: (state) => state.chat.autoTranslate,
            settings: (state) => state.setting.settings,
        }),
        isGroupMessage() {
            return !!_.get(this.message, "raw.whatsappAuthor.author");
        },
        whatsappAuthorNumber() {
            return _.get(this.message, "raw.whatsappAuthor.author", "").replace(/[^0-9]/g, "");
        },
        whatsappAuthorName() {
            return _.get(this.message, "raw.whatsappAuthor.authorName", "");
        },
        isTranslateOpen() {
            if (!this.settings.autoTranslate) return false;
            const contact = this.$store.state.contact.selectedContact;
            const lastConversationId = _.get(contact, "lastConversation._id", "");
            return (
                (!this.disableTranslation && !this.isChatWindow) ||
                (lastConversationId && !!this.autoTranslate.includes(lastConversationId))
            );
        },
        messageText() {
            let message =
                (_.get(this.message, "data.text") || _.get(this.message, "raw.payload.text") || "").toString() || "";
            // log.debug("message", message, message.trim, this.message);
            message = message.trim();

            const isVisitorMessage = this.message.position !== "right";
            const contact = this.$store.state.contact.selectedContact;
            const platform = _.get(contact, "platform", "web");

            let escaped;

            // Önce decode et
            if (isVisitorMessage && platform && platform !== "web") {
                // Visitor mesajları: Tam decode
                escaped = htmlUnescape(message);
            } else {
                // Agent mesajları: Kısmi decode (&lt; ve &gt; decode ETME)
                escaped = message
                    .replace(/&quot;/g, '"')
                    .replace(/&#39;/g, "'")
                    .replace(/&amp;/g, "&")
                    .replace(/&nbsp;/g, " ");
            }

            // Her iki tarafta da platform formatlarını HTML'e çevir
            // Private message'larda formatlama yapma
            if (!this.isPrivateMessage) {
                try {
                    // Platform formatlarını HTML'e çevir (*bold*, ~strikethrough~, vb.)
                    escaped = formatter.platform(platform || "web").parse(escaped);
                } catch (error) {
                    console.error("Message parse error:", error);
                }
            }

            let res = Autolinker.link(escaped, {
                className: "a-link",
                truncate: { length: 50, location: "smart" },
            });
            res = this.fillLinkTargetBlank(res);
            res = res.replace(/<p>&nbsp;<\/p>$/gi, "");
            res = SanitizeHtml(res);
            return res;
        },
        me() {
            return this.message.position === "right";
        },
        translate() {
            if (this.message.raw.translates && this.message.raw.translates.length > 0) {
                this.translateOff = false;
                return this.message.raw.translates.find((x) => x.to === this.myLang);
            } else {
                this.translateOff = true;
                return false;
            }
        },
        commentReplyLabel() {
            // User mesajı için comment_reply kontrolü
            const isCommentReply = _.get(this.message, "raw.payload.comment_reply") === true;
            if (isCommentReply) {
                const replyType = _.get(this.message, "raw.payload.reply_type");
                if (replyType === 'dm') {
                    return "Yorum DM'den cevaplandı";
                } else if (replyType === 'comment') {
                    return "Yorum olarak cevaplandı";
                }
            }

            // // Visitor mesajı için replyTo.messageType kontrolü
            // const replyToMessageType = _.get(this.message, "raw.replyTo.messageType");
            // if (replyToMessageType === "meta-post") {
            //     return "Yorum";
            // }

            return null;
        },
    },
    methods: {
        formatDate(message) {
            const date = _.get(message, "raw.createdDate", _.get(message, "data.startTimestamp"), null);
            return date
                ? new Date(date).toLocaleString("tr-TR", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                })
                : "";
        },
        getWhatsappNumberColor() {
            if (this.isGroupMessage) {
                const baseColor = "rgb(241, 244, 247)";
                const numberColor = StringUtils.stringToColor(this.whatsappAuthorNumber);
                return this.getContrastColor(baseColor, numberColor);
            }
            return this.messageColors.color;
        },
        getContrastColor(bgColor, textColor) {
            const colors = ["#1a5fb4", "#813d9c", "#c64600", "#2ec27e", "#e01b24", "#3584e4", "#9141ac", "#f5c211"];
            const index = Math.abs(this.hashCode(this.whatsappAuthorNumber)) % colors.length;
            return colors[index];
        },
        hashCode(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
        determineColor(message) {
            const name = message.author;
            const isRight = this.message.position === "right";
            let color = ";";
            if (isRight && this.isColored && this.userName !== name) {
                let hash = this.hashCode(name);
                let index = hash % this.colors.length;
                color = this.colors[index];
            } else if (this.isColored && this.userName === name) {
                color = "#4e8cff";
            } else if (!this.isColored && !isRight) {
                color = "#EAEAEA";
            } else {
                color = "";
            }

            return color;
        },
        isTranslatable() {
            try {
                const translates = _.get(this.message, "raw.translates", []) || [];
                const from = _.get(translates, "0.from", "") || "";
                const to = _.get(translates, "0.to", "") || "";
                const text = _.get(translates, "0.text", "") || "";
                const emoji = this.isEmoji();
                return translates.length > 0 && this.autoTranslate && from !== to && !emoji && !!text;
            } catch (e) {
                console.error(e);
                return false;
            }
        },
        isEmoji() {
            try {
                const ranges = [
                    "\ud83c[\udf00-\udfff]", // U+1F300 to U+1F3FF
                    "\ud83d[\udc00-\ude4f]", // U+1F400 to U+1F64F
                    "\ud83d[\ude80-\udeff]", // U+1F680 to U+1F6FF
                ];
                const message = (this.messageText || "").trim();
                const regex = new RegExp(`^(${ranges.join("|")})$`);
                const el = document.createElement("div");
                el.innerHTML = message;
                const content = el.textContent || el.innerText || "";
                if (content.match(regex)) {
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                console.error(e);
                return false;
            }
        },

        fillLinkTargetBlank(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
        metaShorter(text) {
            let delimiter = " - ";
            let t = text.split(delimiter);
            if (t[0].length > 11) t[0] = t[0].slice(0, 11) + "..";
            return t.join(delimiter);
        },
        translateMsg() {
            this.translating = true;
            systemMessageStream
                .pipe(
                    filter((x) => x.type === "translate_message"),
                    map((x) => x.payload),
                    filter((x) => x.uniqMessageId === this.message.raw.uniqMessageId),
                    filter((x) => Array.isArray(x.translates) && !!x.translates.find((y) => y.to === this.myLang))
                )
                .subscribe((x) => {
                    log("translate received");
                    this.translating = false;
                });
            sendSocketMessage("user translate-message", {
                siteId: this.site._id,
                to: this.myLang,
                data: {
                    ...this.message.raw,
                    message: this.message.raw.description,
                    conversationId: this.message.raw.conversationId || this.message.raw.conversation,
                },
            });
        },
    },
    mounted() { },
    components: {
        QuoteMessage,
        TranslatedText,
        IconBase,
        IconCross,
        IconEdit,
        SupsisText,
        Modal2,
        WhatsappChatStarter,
    },
};
</script>

<style lang="scss">
.sc-message--text {
    &.emoji {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        font-size: 30px !important;
        padding: 0 !important;

        .sc-message-meta-new {
            color: black !important;
            margin: 10px !important;
        }
    }

    &.emoji::after {
        content: "" !important;
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
        width: 0 !important;
        height: 0 !important;
        border: 0px solid transparent;
        border-left-color: transparent !important;
        border-right: 0 !important;
        border-top: 0 !important;
        margin-top: 0px !important;
        margin-right: 0 !important;
    }

    .sc-message--content.sent,
    .sc-message--text {
        color: white;
        background-color: #4e8cff;
        max-width: calc(100% - 120px);
        word-wrap: break-word;
        font: 15px / 20px Helvetica, Arial, sans-serif;
    }

    .comment-reply-label {
        font-size: 9px;
        font-weight: 300;
        opacity: 0.7;
        text-align: left;
        line-height: 0;
        margin: 5px;
        margin-bottom: 14px;
        margin-left: 10px;
    }

    .sc-message-meta-new {
        font-size: 8px;
        font-weight: 300;
        color: white;
        text-align: right;
        border-radius: 6px;
        text-transform: uppercase;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 0px !important;
        margin: 5px !important;
        margin-right: 14px !important;
        margin-bottom: 14px !important;
    }

    .translate-this-text {
        font-size: 10px;
        text-decoration: underline;
    }

    .after-translate-top {
        border-radius: 6px 6px 0px 0px;
    }

    .after-translate-mid {
        background: #d9d3d3;
    }

    .after-translate-bottom {
        border-radius: 0px 0px 6px 6px;
        background: #d9d3d3;
    }

    a.chatLink {
        color: white !important;
    }

    a.chatLink-phone {
        color: inherit !important;
    }

    p {
        a {
            color: inherit !important;
        }
    }
}

.edit-icon {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    display: none;
    border-radius: 0 0 0 6px;
    padding: 0.2rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.sc-message--text:hover .edit-icon {
    display: block;
}

.whatsapp-number {
    cursor: pointer;

    a {
        text-decoration: underline;
    }
}

.whatsapp-number-first {
    cursor: pointer;
    font-size: smaller;
    font-weight: 200;
    letter-spacing: 2px;

    a {
        &:hover {
            text-decoration: underline;
        }
    }

    padding: 5px;
}
</style>
